module.exports = __webpack_public_path__ + "static/media/about-us-hero.c30f470e.jpg";